var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarUserBoldDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 16.6663C23.6806 16.6663 26.6654 13.6816 26.6654 9.99967C26.6654 6.31778 23.6806 3.33301 19.9987 3.33301C16.3168 3.33301 13.332 6.31778 13.332 9.99967C13.332 13.6816 16.3168 16.6663 19.9987 16.6663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3346 29.167C33.3346 33.3087 33.3346 36.667 20.0013 36.667C6.66797 36.667 6.66797 33.3087 6.66797 29.167C6.66797 25.0253 12.638 21.667 20.0013 21.667C27.3646 21.667 33.3346 25.0253 33.3346 29.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarUserBoldDuotone);
export default __webpack_public_path__ + "static/media/solar_user-bold-duotone.4932b59c723031578a7173235f103f06.svg";
export { ForwardRef as ReactComponent };